import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCampaigns } from "../../../slices/campaigns/thunk";
import { toggleCreateCampaignModal, toggleDeleteAllModal, toggleDuplicateAllModal, toggleFolderModal } from "../../../slices/modals/reducer";
import { useLocation, NavLink, useParams } from "react-router-dom";
import classnames from "classnames";
import { Card, CardHeader, CardBody, Nav, NavItem, Container, Button, Input } from "reactstrap";
import AdLibraryTable from "./AdLibraryTable";
// import DeleteTableItemModal from "./DeleteTableItemModal";
import { createSelector } from "reselect";
import { replace } from "redux-first-history";
import { getAllLibrariesSuccess, setAllLibrariesFirstLoad, setAllLibrariesHasMore, setAllLibrariesLoading, setAllLibrariesPage, setAllLibrariesShowLoader, setCampaignLoader, setFilter } from "../../../slices/campaigns/reducer";
import { setPreloader } from "../../../slices/layouts/reducer";
import { getFolderRootThunk, newFolder, setFolderHistory } from "../../../slices/folder/thunk";
import { setFolderRootPath } from "../../../slices/folder/reducer";
import { setBreadcrumb, setFolderPath } from "../../../slices/auth/menu/reducer";
import Filter from "./Filter";
import DuplicateAllModal from "./DuplicateAllModal";
import DeleteAllModal from "./DeleteAllModal";
import FolderModal from "../../Folder";
import checkPermission from "../../../Components/Hooks/PermissionHook";
import TableDeleteButton from "../../Folder/Components/TableDeleteButton";
import TableMoveButton from "../../Folder/Components/TableMoveButton";
import TableDuplicateButton from "../../Folder/Components/TableDuplicateButton";
import NewFolderDropdown from "../../Folder/Components/NewFolderDropdown";
import CreateAdButton from "./CreateAdButton";
import EditTableItemModal from "../../Folder/EditTableItemModal";
import DeleteTableItemModal from "../../Folder/DeleteTableItemModal";
import CreateCampaignModal from "../CreateCampaignModal";
import { calculateTablePage } from "../../../slices/folder/helper";

function AllLibraries() {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const path = location.pathname.replace("/campaigns/", "");
  const searchParams = new URLSearchParams(location.search);
  const folderId = searchParams.get('folderId');

  const selectStates = createSelector(state => state, state => ({
    clientPath: state.MenuData.clientPath,
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath,
    previousLocations: state.router.previousLocations,
    selectedItems: state.Folder.selectedItems,
    filter: state.Folder.filter,
    title: state.MenuData.title,
    allLibraries: state.Campaign.allLibraries,
    allLibrariesHasMore: state.Campaign.allLibrariesHasMore,
    allLibrariesPage: state.Campaign.allLibrariesPage,
  }));
  const {
    clientPath,
    brandPath,
    marketPath,
    previousLocations,
    selectedItems,
    filter,
    title,
    allLibraries,
    allLibrariesHasMore,
    allLibrariesPage,
  } = useSelector(selectStates);

  useEffect(() => {
    if (brandPath !== null) {
      if (location.search === "") {
        dispatch(setFolderPath(null));
      } else {
        dispatch(setFolderPath(location.search.split("=")[1]));
      }
      if (previousLocations[0].location.state === null && (previousLocations[0].action === "PUSH" || previousLocations[0].action === "POP")) {
        dispatch(setCampaignLoader(true));
        dispatch(getCampaigns()).then(res => {
          let campaignsRes = [];
          if (Array.isArray(res.payload) && res.payload.length > 0) {
            campaignsRes = res.payload;
          }
          const updatedBreadcrumbTitle = [];
          if (title && title.length === 0) {
            let adLibPath = `/${params.client}/${params.brand}`;
            if (params.market) {
              adLibPath += `/${params.market}`;
            }
            adLibPath += '/campaigns/filter/all';
            updatedBreadcrumbTitle.push({ name: 'Ad Library', src: adLibPath });
          } else if (title && title.length > 0) {
            updatedBreadcrumbTitle.push(...title);
          }
          dispatch(replace(location.pathname, {
            campaigns: [...campaignsRes],
            title: updatedBreadcrumbTitle,
            hasMore: true,
            firstLoad: false,
            campaignPage: calculateTablePage(campaignsRes.length)
          }
          ));
          dispatch(setCampaignLoader(false));
        });
      }
      else if (previousLocations[0].location.state !== null) {
        dispatch(getAllLibrariesSuccess(previousLocations[0].location.state.campaigns));
        dispatch(setBreadcrumb({ pageTitle: 'Ad Library', title: previousLocations[0].location.state.title }));
        dispatch(setAllLibrariesHasMore(previousLocations[0].location.state.hasMore));
        if (previousLocations[0].action === 'POP') {
          dispatch(setAllLibrariesFirstLoad(false));
        } else {
          dispatch(setAllLibrariesFirstLoad(previousLocations[0].location.state.firstLoad));
        }
        dispatch(setAllLibrariesPage((previousLocations[0].location.state.campaignPage ?
          previousLocations[0].location.state.campaignPage
          :
          calculateTablePage(previousLocations[0].location.state.campaigns?.length)
        )));
        if (previousLocations[0].location.state.isLoading) {
          dispatch(setAllLibrariesLoading(previousLocations[0].location.state.isLoading));
        }
        if (previousLocations[0].location.state.showLoader) {
          dispatch(setAllLibrariesShowLoader(previousLocations[0].location.state.showLoader));
        }
      }
    }
  }, [clientPath, brandPath, marketPath, location.search]);

  async function openCampaignFolder() {
    dispatch(setFolderHistory([{ name: "Ad Library" }]))
    dispatch(setFolderRootPath("campaign"));
    await dispatch(getFolderRootThunk());
    dispatch(toggleFolderModal());
  }

  async function newFolderFunction(data) {
    const folderObj = await dispatch(newFolder({ ...data, type: "campaign" }))
    if (folderObj) {
      const updatedCampaigns = [folderObj, ...allLibraries];
      dispatch(getAllLibrariesSuccess(updatedCampaigns));
      dispatch(setAllLibrariesFirstLoad(false));
      dispatch(replace(window.location.href, {
        title: title,
        campaigns: updatedCampaigns,
        hasMore: allLibrariesHasMore,
        firstLoad: false,
        campaignPage: allLibrariesPage
      }));
    }
  }

  let typingTimer;
  let doneTypingInterval = 500;
  async function handleSearch(e) {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      dispatch(getAllLibrariesSuccess(null));
      dispatch(setAllLibrariesLoading(false));
      dispatch(setAllLibrariesHasMore(true));
      dispatch(setAllLibrariesFirstLoad(false));
      dispatch(setAllLibrariesPage(1));
      if (e.target.value === "" || e.target.value === " ") {
        dispatch(setFilter({ ...filter, query: null }));
        const res = await dispatch(getCampaigns());
        dispatch(getAllLibrariesSuccess(res.payload));
      } else {
        dispatch(setFilter({ ...filter, query: e.target.value }));
        const res = await dispatch(getCampaigns());
        dispatch(getAllLibrariesSuccess(res.payload));
      }
    }, doneTypingInterval);
  }

  function handleFolderPath() {
    if (folderId) {
      return `?folderId=${folderId}`
    } else {
      return '';
    }
  }

  return (
    <Card>
      <CardHeader>
        <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0 justify-content-center" role="tablist">
          <NavItem>
            <NavLink
              to={"all" + handleFolderPath()}
              className={"nav-link " + classnames({ active: path == "all" })}
              type="button">
              <i className="fas fa-home"></i>
              All
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              to={"display" + handleFolderPath()}
              className={"nav-link " + classnames({ active: path == "display" })}
              type="button">
              <i className="far fa-user"></i>
              Display
            </NavLink>
          </NavItem>
          <NavItem >
            <NavLink to={"social" + handleFolderPath()}
              className={"nav-link " + classnames({ active: path === "social" })}
              type="button">
              <i className="far fa-envelope"></i>
              Paid Social
            </NavLink>
          </NavItem>
          {/* <NavItem>
            <NavLink to="video"
              className={"nav-link " + classnames({ active: path === "video" })}
              type="button">
              <i className="far fa-envelope"></i>
              Video
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="audio"
              className={"nav-link " + classnames({ active: path === "audio" })}
              type="button">
              <i className="far fa-envelope"></i>
              Audio
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink to="crm"
              className={"nav-link " + classnames({ active: path === "crm" })}
              type="button">
              <i className="far fa-envelope"></i>
              CRM
            </NavLink>
          </NavItem> */}
          <div className='d-flex gap-1 ms-auto me-0 my-auto'>
            <CreateAdButton />
            {params.market ?
              <NewFolderDropdown newFolderFunction={newFolderFunction} />
              : null}
          </div>
        </Nav>
      </CardHeader>
      <CardBody>
        <div className='d-flex flex-wrap align-items-center justify-content-between gap-2' style={{ margin: "0 -0.5rem" }}>
          <div className='d-flex gap-1'>
            {selectedItems.length > 0 ?
              <div className="d-flex align-items-center gap-1">
                {params.market ?
                  <TableMoveButton allowedPermission={"campaignCreate"} onClick={openCampaignFolder} />
                  : null}
                <TableDuplicateButton allowedPermission={"campaignCreate"} onClick={() => dispatch(toggleDuplicateAllModal())} />
                <TableDeleteButton allowedPermission={"campaignDelete"} onClick={() => dispatch(toggleDeleteAllModal())} />
              </div>
              : null}
          </div>
          <div className="d-flex align-items-center gap-1">
            <div className="form-icon">
              <Input type="text" className="form-control form-control-icon" placeholder="Search Ads" onKeyUp={handleSearch} />
              <i className="ri-search-line search-icon text-muted"></i>
            </div>
            <Filter />
          </div>
        </div>
        <AdLibraryTable />
        <FolderModal />
        {/* <DeleteCampaignModal /> */}
        <CreateCampaignModal />
        <DeleteTableItemModal />
        <DuplicateAllModal />
        <DeleteAllModal />
        <EditTableItemModal />
      </CardBody>
    </Card>
  );
}

export default AllLibraries;